import type { CreditBalance } from '@studio/contract';
import { useQuery } from '@tanstack/react-query';
import { useStudioClient } from '../context';
import { parseApiError } from '../errors';

/**
 * `GET /api/credits/balance` (iter 85) — the active workspace's credit
 * balance + plan tier + next renewal. Powers the Photo Studio credits
 * chip and the Fit-to-budget math.
 *
 * Stale-while-revalidate-friendly: the balance changes server-side on
 * each successful generation, so call sites that mutate (Generate, etc.)
 * should invalidate the `['creditBalance']` query key on success to
 * force a refetch.
 */
export function useCreditBalance() {
  const client = useStudioClient();
  return useQuery({
    queryKey: ['creditBalance'],
    queryFn: async () => {
      const res = await client.api.credits.balance.$get();
      if (!res.ok) throw await parseApiError(res);
      return (await res.json()) as CreditBalance;
    },
  });
}
